import type { ReactNode } from 'react';
import { Container, type ContainerPad, type ContainerWidth } from '@src/components/Container/Container';

export interface PageContentProps {
  children?: ReactNode;
  /** medium / full — defaults to full. */
  width?: ContainerWidth;
  /** Vertical inset for the main column. Most pages use `page`; box screens use `box`. */
  pad?: ContainerPad;
  className?: string;
  testId?: string;
}

/**
 * Standard product column — header, footer and main share the same max-width.
 * Pages should use this instead of picking a Container width directly.
 */
export function PageContent({
  children,
  width = 'full',
  pad = 'page',
  className,
  testId,
}: PageContentProps) {
  return (
    <Container
      width={width}
      gutter="default"
      pad={pad}
      grow
      as="main"
      className={className}
      testId={testId}
    >
      {children}
    </Container>
  );
}
